import React, { useContext, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import styles from "@/page-components/savings/components/savings.module.css";
import { RiContexts } from "../right.context";

const RiTabs = () => {
  const context = useContext(RiContexts);

  const tableChange = (e) => {
    context.setEventkey(e);
  };

  return (
    <div className="btn__Container">
      <div className="btn-combo__Container">
        <Tabs
          defaultActiveKey={context.eventkey}
          className={styles.mytabs_button}
          fill
          onSelect={(e) => {
            tableChange(e);
          }}
          style={{ gap: "4px" }}
        >
          <Tab eventKey="Rightsizing" title="Rightsizing"></Tab>
          <Tab eventKey="RI Recommendations" title="RI Recommendations"></Tab>
          {/* <Tab
            eventKey="Bulk Recommendations"
            title="Bulk Recommendations"
          ></Tab>
          <Tab
            eventKey="Scope & Instance Flexibility Recommendations"
            title="Scope & Instance Flexibility Recommendations"
          ></Tab> */}
        </Tabs>
      </div>
      <div className="text-btn__Container">Updated Today at 7:05AM</div>
    </div>
  );
};

export default RiTabs;
